/** Catalogo icone custom Immigreer — file in public/icons/<key>.png */
export interface ImmiIcon {
  key: string
  label: string
}

export const IMMI_ICONS: ImmiIcon[] = [
  { key: 'ospiti',          label: 'Ospiti' },
  { key: 'operatori',       label: 'Operatori' },
  { key: 'operatore',       label: 'Operatore' },
  { key: 'gestioneCentri',  label: 'Gestione Centri' },
  { key: 'calendario',      label: 'Calendario' },
  { key: 'timbratura',      label: 'Timbratura' },
  { key: 'mezzoTimbratura', label: 'Mezzo Timbratura' },
  { key: 'nfc',             label: 'NFC / Timbratura' },
  { key: 'checkIn',         label: 'Check-In' },
  { key: 'checkIn2',        label: 'Check-In (alt)' },
  { key: 'listaPresenze',   label: 'Lista Presenze' },
  { key: 'turnazione',      label: 'Turnazione' },
  { key: 'diario',          label: 'Diario' },
  { key: 'doc',             label: 'Documenti' },
  { key: 'cf',              label: 'Codice Fiscale' },
  { key: 'effetti',         label: 'Effetti Personali' },
  { key: 'message',         label: 'Messaggi' },
  { key: 'home',            label: 'Home' },
  { key: 'areaUtente',      label: 'Area Utente' },
  { key: 'elenco',          label: 'Elenco' },
  { key: 'lista',           label: 'Lista' },
  { key: 'elencoStrutture', label: 'Elenco Strutture' },
  { key: 'guasti',          label: 'Guasti' },
  { key: 'bustapaga',       label: 'Busta Paga' },
  { key: 'richiestaPasti',  label: 'Richiesta Pasti' },
  { key: 'spaccio',         label: 'Spaccio' },
  { key: 'listaSpesa',      label: 'Lista Spesa' },
  { key: 'articoli',        label: 'Articoli' },
  { key: 'badge',              label: 'Badge / Immibadge' },
  { key: 'mezzi',              label: 'Mezzi' },
  // Macro-sezioni menu
  { key: 'assistenza',         label: 'Assistenza / Helpdesk' },
  { key: 'areaMedica',         label: 'Area Medica' },
  { key: 'acquistiFornitori',  label: 'Acquisti / Fornitori' },
  { key: 'areaSociale',        label: 'Area Sociale' },
  { key: 'amministrazione',    label: 'Amministrazione' },
  { key: 'protocollo',         label: 'Protocollo' },
  { key: 'workspace',          label: 'Workspace' },
  // Sottovoci calendario
  { key: 'appuntamenti',       label: 'Appuntamenti' },
  { key: 'tipologieAttivita',  label: 'Tipologie Attività' },
  // Documentale
  { key: 'documentiCentro',    label: 'Documenti Centro' },
  { key: 'tipologiaDoc',       label: 'Tipologia Documento' },
  { key: 'modelli',            label: 'Modelli Documento' },
  { key: 'scadenze',           label: 'Scadenze' },
  // Comunicazioni
  { key: 'mail',               label: 'Mail / Webmail' },
  { key: 'mailAccounts',       label: 'Account Mail' },
  // Strutture / Anagrafica
  { key: 'azienda',            label: 'Azienda / Ente' },
  { key: 'scheda',             label: 'Scheda / Card' },
  { key: 'anagraficaOspite',   label: 'Anagrafica Ospite' },
  { key: 'ingressi',           label: 'Ingressi / Uscite' },
  { key: 'prenotazione',       label: 'Prenotazione' },
  // Sistema
  { key: 'plugin',              label: 'Plugin / Estensioni' },
  { key: 'configurazione',      label: 'Configurazione' },
  { key: 'configurazioneAdmin', label: 'Configurazione Admin' },
  // Sezioni legacy
  { key: 'areaScolastica',      label: 'Area Scolastica' },
  { key: 'gestioneMensa',       label: 'Gestione Mensa' },
  { key: 'gestioneMagazzino',   label: 'Gestione Magazzino' },
  { key: 'contabilita',         label: 'Contabilità' },
  { key: 'gestioneReport',      label: 'Gestione Report' },
  { key: 'mediazione',          label: 'Mediazione' },
  { key: 'areaLavoro',          label: 'Area di Lavoro' },
  // Area Scolastica
  { key: 'calendarioFormazione',  label: 'Calendario Formazione' },
  { key: 'presenzeFormazione',    label: 'Presenze Formazione' },
  { key: 'diarioFormazione',      label: 'Diario Formazione' },
  // Gestione Mensa
  { key: 'consegnaPasti',         label: 'Consegna Pasti' },
  { key: 'presenzeMensa',         label: 'Presenze Mensa' },
  // Gestione Magazzino
  { key: 'giacenze',              label: 'Giacenze' },
  { key: 'anagraficaArticoli',    label: 'Anagrafica Articoli' },
  { key: 'autorizzaOrdine',       label: 'Autorizza Ordine' },
  { key: 'reportMagazzino',       label: 'Report Magazzino' },
  // Contabilità
  { key: 'fornitori',             label: 'Fornitori' },
  { key: 'vociSpesa',             label: 'Voci di Spesa' },
  { key: 'documentiSpesa',        label: 'Documenti di Spesa' },
  { key: 'scadenzaPagamenti',     label: 'Scadenza Pagamenti' },
  { key: 'rendicontoSpese',       label: 'Rendiconto Spese' },
  // Area Lavoro
  { key: 'elencaLavoratori',      label: 'Elenco Lavoratori' },
  { key: 'colloquiLavoro',        label: 'Colloqui Lavoro' },
  { key: 'esperienzeLavorative',  label: 'Esperienze Lavorative' },
  { key: 'aziendePartner',        label: 'Aziende Partner' },
  // Gestione Ospiti
  { key: 'entrataOspiti',        label: 'Entrata Ospiti' },
  { key: 'uscitaOspiti',         label: 'Uscita Ospiti' },
  { key: 'entrataUscitaOspiti',  label: 'Entrata/Uscita Ospiti' },
  { key: 'trasferisciOspite',    label: 'Trasferisci Ospite' },
  { key: 'presenzaOspiti',       label: 'Presenza Ospiti' },
  { key: 'registroPermessi',     label: 'Registro Permessi' },
  { key: 'attiVandalici',        label: 'Atti Vandalici / Eventi Critici' },
  { key: 'gestionePocketMoney',  label: 'Gestione Pocket Money' },
  { key: 'reportOspiti',         label: 'Report Ospiti' },
  // Gestione Personale
  { key: 'accessoPortale',               label: 'Accesso al Portale' },
  { key: 'permessiUtente',               label: 'Permessi Utente' },
  { key: 'logAttivita',                  label: 'Log Attività' },
  { key: 'rettificaTimbratura',          label: 'Rettifica Timbratura' },
  { key: 'elencoDocPersonale',           label: 'Elenco Documenti Personale' },
  { key: 'prenotazionePastiPersonale',   label: 'Prenotazione Pasti' },
  { key: 'richiestePersonale',           label: 'Richieste Personale' },
  { key: 'verificaRichieste',            label: 'Verifica Richieste' },
  { key: 'autorizzaRichieste',           label: 'Autorizza Richieste' },
  { key: 'eliminaRichieste',             label: 'Elimina Richieste' },
  { key: 'configuraTurnazione',          label: 'Configura Turnazione' },
  { key: 'reportPersonale',              label: 'Report Personale' },
  { key: 'mansioni',                     label: 'Mansioni' },
  // Gestione Centri
  { key: 'nuovoCentro',           label: 'Nuovo Centro' },
  { key: 'datiTecnici',           label: 'Dati Tecnici Centro' },
  { key: 'cassaCentro',           label: 'Cassa Centro' },
  { key: 'nuovaStruttura',        label: 'Nuova Struttura' },
  { key: 'assegnaReferenti',      label: 'Assegna Referenti Struttura' },
  { key: 'associaArticoliCentri', label: 'Associa Articoli ai Centri' },
  { key: 'registroVisitatori',    label: 'Registro Visitatori' },
  { key: 'rubrica',               label: 'Rubrica' },
  { key: 'convalidaTicket',       label: 'Convalida Ticket' },
  { key: 'gestiTurnazione',       label: 'Gestisci Turnazione' },
  { key: 'caricoTurnazione',      label: 'Carico Turnazione' },
  { key: 'autorizzaTurnazione',   label: 'Autorizza Turnazione' },
  { key: 'lavoraTurnazione',      label: 'Lavora Turnazione' },
  // Area Medica
  { key: 'schedaMedica',            label: 'Scheda Medica' },
  { key: 'documentiSanitari',       label: 'Documenti Sanitari' },
  { key: 'terapia',                 label: 'Terapie' },
  { key: 'farmaci',                 label: 'Farmaci' },
  { key: 'consulenzaMedica',        label: 'Consulenza Medica' },
  { key: 'reportMedica',            label: 'Report Area Medica' },
  // Area Sociale
  { key: 'schedaAccoglienza',       label: 'Scheda Accoglienza' },
  { key: 'schedaSociale',           label: 'Scheda Sociale' },
  { key: 'schedaPsicologica',       label: 'Scheda Psicologica' },
  { key: 'diarioBordoSociale',      label: 'Diario di Bordo Sociale' },
  { key: 'diarioBordoMediazione',   label: 'Diario di Bordo Mediazione' },
  { key: 'diarioBordoPsicologi',    label: 'Diario di Bordo Psicologi' },
  { key: 'diarioBordoLegale',       label: 'Diario di Bordo Legale' },
  { key: 'protezioneInternazionale', label: 'Protezione Internazionale' },
  { key: 'vulnerabilita',           label: 'Vulnerabilità' },
  { key: 'reportSociale',           label: 'Report Area Sociale' },
  // Assistenza/Helpdesk
  { key: 'iMieiTicket',             label: 'I Miei Ticket' },
  { key: 'nuovoTicket',             label: 'Nuovo Ticket' },
  { key: 'codaHelpdesk',            label: 'Coda Helpdesk' },
  { key: 'configHelpdesk',          label: 'Config Helpdesk' },
  // Amministrazione
  { key: 'ruoliAmm',            label: 'Ruoli' },
  { key: 'diagnostica',         label: 'Diagnostica' },
  { key: 'guide',               label: 'Guide' },
  { key: 'notificheEmail',      label: 'Notifiche Email' },
  { key: 'logUtenti',           label: 'Log Utenti' },
  { key: 'gestioneMenu',        label: 'Gestione Menu' },
  { key: 'configurazioneAI',    label: 'Configurazione AI' },
  { key: 'traduzioni',          label: 'Traduzioni' },
  // Gestione Mezzi
  { key: 'movimentazioneMezzi', label: 'Movimentazione Mezzi' },
  { key: 'calendarioMezzi',     label: 'Calendario Mezzi' },
  // Protocollo
  { key: 'firmaProtocollo',     label: 'Firma Protocollo' },
  { key: 'notifichePEC',        label: 'Notifiche PEC' },
  // Acquisti / Documentale / Calendario
  { key: 'elencoRichieste',     label: 'Elenco Richieste' },
  { key: 'elencoCarte',         label: 'Elenco Carte' },
  { key: 'importMassivo',       label: 'Import Massivo' },
  { key: 'elencoEventi',        label: 'Elenco Eventi' },
  // Amministrazione extra
  { key: 'schedulerAdmin',          label: 'Scheduler' },
  { key: 'configurazionePagine',    label: 'Configurazione Pagine' },
  { key: 'feedbackChatbot',         label: 'Feedback Chatbot' },
  { key: 'elencoLettori',           label: 'Elenco Lettori' },
  // Mediazione subcategorie
  { key: 'calendarioMediazione',    label: 'Calendario Mediazione' },
  { key: 'elencoCommittenti',       label: 'Elenco Committenti' },
  { key: 'elencoAmbitiIntervento',  label: 'Elenco Ambiti Intervento' },
  { key: 'elencoMediatori',         label: 'Elenco Mediatori' },
  // Area Sociale extra
  { key: 'diarioBordoAnimazione',   label: 'Diario di Bordo Animazione' },
  { key: 'schedaPersonale',         label: 'Scheda Personale' },
  { key: 'formazioneLavoro',        label: 'Formazione e Lavoro' },
  { key: 'accoglienza',             label: 'Accoglienza' },
  // Area Medica extra
  { key: 'schedaSanitaria',         label: 'Scheda Sanitaria' },
  { key: 'diarioClinico',           label: 'Diario Clinico' },
  { key: 'anagraficaFarmaci',       label: 'Anagrafica Farmaci' },
  { key: 'ricetteMediche',          label: 'Ricette Mediche' },
  // Configurazione Admin / Sistema
  { key: 'gestioneGruppi',          label: 'Gestione Gruppi' },
  { key: 'gestioneUtenti',          label: 'Gestione Utenti' },
  { key: 'elencoFunzioni',          label: 'Elenco Funzioni' },
  { key: 'elencoBanche',            label: 'Elenco Banche' },
  // Voci finali
  { key: 'portaleClassico',             label: 'Portale Classico' },
  { key: 'elencotipoUscita',            label: 'Elenco Motivo Uscita' },
  { key: 'campiPersonalizzati',         label: 'Campi Personalizzati' },
  { key: 'copiaMenu',                   label: 'Copia Menu' },
  { key: 'tipologieVulnerabilita',      label: 'Tipologie Vulnerabilità' },
  { key: 'tipologieAppuntamentiMedici', label: 'Tipologie Appuntamenti Medici' },
  { key: 'elencoConsulenzeCategorie',   label: 'Categorie Consulenze' },
  { key: 'prendiInCaricoGuasto',        label: 'Prendi in Carico Guasto' },
  { key: 'elencoAppuntamenti', label: 'Elenco Appuntamenti' },
]

/** Subset di PrimeIcons rilevanti per le sezioni dell'applicazione */
export const PRIME_ICONS: string[] = [
  'pi pi-home', 'pi pi-calendar', 'pi pi-calendar-plus', 'pi pi-users', 'pi pi-user',
  'pi pi-id-card', 'pi pi-building', 'pi pi-headphones', 'pi pi-shield', 'pi pi-sitemap',
  'pi pi-list', 'pi pi-list-check', 'pi pi-envelope', 'pi pi-megaphone', 'pi pi-bell',
  'pi pi-ticket', 'pi pi-inbox', 'pi pi-sliders-h', 'pi pi-clock', 'pi pi-stopwatch',
  'pi pi-chart-bar', 'pi pi-chart-line', 'pi pi-chart-pie', 'pi pi-history',
  'pi pi-book', 'pi pi-file', 'pi pi-folder', 'pi pi-download', 'pi pi-upload',
  'pi pi-plug', 'pi pi-cog', 'pi pi-wrench', 'pi pi-server', 'pi pi-database',
  'pi pi-desktop', 'pi pi-mobile', 'pi pi-tablet', 'pi pi-qrcode', 'pi pi-barcode',
  'pi pi-map-marker', 'pi pi-map', 'pi pi-car', 'pi pi-truck',
  'pi pi-wallet', 'pi pi-credit-card', 'pi pi-money-bill',
  'pi pi-search', 'pi pi-eye', 'pi pi-lock', 'pi pi-unlock',
  'pi pi-check', 'pi pi-times', 'pi pi-plus', 'pi pi-minus',
  'pi pi-pencil', 'pi pi-trash', 'pi pi-copy', 'pi pi-link',
  'pi pi-share-alt', 'pi pi-send', 'pi pi-globe', 'pi pi-wifi',
  'pi pi-tag', 'pi pi-tags', 'pi pi-star', 'pi pi-heart',
  'pi pi-info-circle', 'pi pi-question-circle', 'pi pi-exclamation-triangle', 'pi pi-ban',
  'pi pi-image', 'pi pi-camera', 'pi pi-video', 'pi pi-table',
  'pi pi-box', 'pi pi-briefcase', 'pi pi-shopping-cart', 'pi pi-shop',
  'pi pi-user-edit', 'pi pi-user-plus', 'pi pi-user-minus',
  'pi pi-arrow-up', 'pi pi-arrow-down', 'pi pi-arrow-right', 'pi pi-arrow-left',
  'pi pi-angle-right', 'pi pi-angle-down', 'pi pi-external-link', 'pi pi-refresh',
]
/** Converte una stringa icona in src immagine oppure null se non è immi: */
export function resolveImmiSrc(icon: string | null | undefined): string | null {
  if (!icon?.startsWith('immi:')) return null
  const chiave = icon.slice('immi:'.length)
  // Solo una chiave semplice: `../x`, `?`, `#`, `/` cambierebbero la risorsa richiesta.
  if (!/^[A-Za-z0-9_-]+$/.test(chiave)) return null
  return `/icons/${chiave}.png`
}

/** True se l'icona è una icona Immigreer custom */
export function isImmiIcon(icon: string | null | undefined): boolean {
  return icon?.startsWith('immi:') ?? false
}
